import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const updateCheckCreatedWebhook = (axios: IAxiosInstance) => {
  return async ({
    checkCreatedWebhook,
    userType,
    isTestWebhookType,
    usePrimary,
  }: ISchema["#/definitions/IUpdateCheckCreatedWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateCheckCreatedWebhookResponse"]
    >(`/api/updateCheckCreatedWebhook${getUsePrimaryUrlParams(usePrimary)}`, {
      check_created_webhook: checkCreatedWebhook,
      user_type: userType,
      is_test_webhook_type: isTestWebhookType,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
